var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"pt-2":"","pb-1":""}},[_c('page-title',{attrs:{"title":"貨運列表"}})],1),_c('liff-list',{attrs:{"listKey":_vm.listKey},on:{"sortEnd":_vm.sortEnd}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }